Vue.component('admin-subscription', {
    template: templates.adminSubscription,
    data() {
        return {
          model: {
            edit: false,
            subscription: {
                id: null,
                name: null,
                price: 0,
                standard: 0,
                ultra: 0,
                legendary: 0,
                primeChest: 0,
                ultraChest: 0,
                legendaryChest: 0,
                tournament: false,
                streamerTournament: false,
                communityRewards: false,
                exclusiveEvents: false,
                stripePriceId: null,
                stripeProductId: null
            },
            subscriptions: [],
            banner: {
                id: null,
                active: false,
                // Content
                title: '',
                description: '',
                discountText: '',
                buttonText: '',
                buttonLink: '#subscriptions',
                // Layout
                contentPosition: 'left',
                contentAlignment: 'left',
                height: 200,
                borderRadius: 10,
                padding: 30,
                // Background
                backgroundType: 'gradient',
                backgroundColor: '#1a1a2e',
                gradientStart: '#667eea',
                gradientEnd: '#764ba2',
                gradientDirection: 'to right',
                backgroundImage: '',
                backgroundSize: 'cover',
                overlayColor: '#000000',
                overlayOpacity: 0.5,
                // Display Image
                displayImage: '',
                imagePosition: 'right',
                imageWidth: 150,
                imageHeight: 150,
                // Typography
                titleColor: '#ffffff',
                titleSize: 28,
                descriptionColor: '#e0e0e0',
                descriptionSize: 16,
                discountBgColor: '#ff6b6b',
                discountTextColor: '#ffffff',
                // Button
                buttonBgColor: '#4CAF50',
                buttonTextColor: '#ffffff',
                buttonBorderRadius: 5,
                buttonPadding: '10 20'
            }
          }
        }
    },
    mounted() {
        const c = this;
        c.get();
        c.getActiveBanner();
    },
    computed: {
        bannerPreviewContainerStyle() {
            return {
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                borderRadius: this.model.banner.borderRadius + 'px',
                boxSizing: 'border-box'
            };
        },
        bannerPreviewStyle() {
            const b = this.model.banner;
            let style = {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                minHeight: b.height + 'px',
                padding: b.padding + 'px',
                borderRadius: b.borderRadius + 'px',
                position: 'relative',
                overflow: 'hidden',
                boxSizing: 'border-box'
            };

            // Content position
            if (b.contentPosition === 'center') {
                style.justifyContent = 'center';
            } else if (b.contentPosition === 'right') {
                style.justifyContent = 'flex-end';
            } else {
                style.justifyContent = 'flex-start';
            }

            // Reverse if image is on left
            if (b.displayImage && b.imagePosition === 'left') {
                style.flexDirection = 'row-reverse';
            }

            // Background
            if (b.backgroundType === 'color') {
                style.backgroundColor = b.backgroundColor;
            } else if (b.backgroundType === 'gradient') {
                style.background = `linear-gradient(${b.gradientDirection}, ${b.gradientStart}, ${b.gradientEnd})`;
            } else if (b.backgroundType === 'image') {
                style.backgroundImage = `url(${b.backgroundImage})`;
                style.backgroundSize = b.backgroundSize;
                style.backgroundPosition = 'center';
                style.backgroundRepeat = 'no-repeat';
            }

            return style;
        },
        bannerContentStyle() {
            const b = this.model.banner;
            let style = {
                position: 'relative',
                zIndex: 2,
                flex: 1
            };

            if (b.contentAlignment === 'center') {
                style.textAlign = 'center';
            } else if (b.contentAlignment === 'right') {
                style.textAlign = 'right';
            } else {
                style.textAlign = 'left';
            }

            return style;
        },
        bannerTitleStyle() {
            const b = this.model.banner;
            return {
                color: b.titleColor,
                fontSize: b.titleSize + 'px',
                fontWeight: 'bold',
                margin: '0 0 10px 0'
            };
        },
        bannerDescriptionStyle() {
            const b = this.model.banner;
            return {
                color: b.descriptionColor,
                fontSize: b.descriptionSize + 'px',
                margin: '0 0 15px 0'
            };
        },
        bannerDiscountStyle() {
            const b = this.model.banner;
            return {
                display: 'inline-block',
                backgroundColor: b.discountBgColor,
                color: b.discountTextColor,
                padding: '5px 15px',
                borderRadius: '20px',
                fontWeight: 'bold',
                fontSize: '14px',
                marginRight: '10px'
            };
        },
        bannerButtonStyle() {
            const b = this.model.banner;
            const paddingValues = b.buttonPadding.split(' ').map(v => v + 'px').join(' ');
            return {
                backgroundColor: b.buttonBgColor,
                color: b.buttonTextColor,
                border: 'none',
                borderRadius: b.buttonBorderRadius + 'px',
                padding: paddingValues,
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px'
            };
        },
        bannerDisplayImageStyle() {
            const b = this.model.banner;
            return {
                width: b.imageWidth + 'px',
                height: b.imageHeight + 'px',
                objectFit: 'contain',
                marginLeft: b.imagePosition === 'right' ? '20px' : '0',
                marginRight: b.imagePosition === 'left' ? '20px' : '0',
                position: 'relative',
                zIndex: 2
            };
        }
    },
    methods: {
        get() {
            const c = this;

            subscriptionService.get().then(function(response) {
                c.model.subscriptions = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        getActiveBanner() {
            const c = this;

            subscriptionService.getLatest().then(function(response) {
                if (response.data && response.data[0]) {
                    const bannerData = response.data[0];
                    c.model.banner.id = bannerData.id;
                    c.model.banner.active = bannerData.active;
                    
                    // Try to parse stored banner config (stored in 'html' column)
                    if (bannerData.html) {
                        try {
                            let configStr = bannerData.html;
                            
                            // Skip if content is legacy HTML (not JSON)
                            if (typeof configStr === 'string' && configStr.trim().startsWith('<')) {
                                console.log('Banner contains legacy HTML, skipping JSON parse');
                            } else {
                                // Handle legacy escaped data (fix double-escaping issue)
                                if (typeof configStr === 'string' && configStr.includes('\\"')) {
                                    configStr = configStr.replace(/\\"/g, '"');
                                }
                                const config = typeof configStr === 'string' 
                                    ? JSON.parse(configStr) 
                                    : configStr;
                                Object.assign(c.model.banner, config);
                            }
                        } catch (e) {
                            console.log('Error parsing banner config:', e);
                        }
                    }
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        reset() {
            const c = this;
            c.model.edit = false;
            c.model.subscription = {
                id: null,
                name: null,
                price: 0,
                standard: 0,
                ultra: 0,
                legendary: 0,
                primeChest: 0,
                ultraChest: 0,
                legendaryChest: 0,
                tournament: false,
                streamerTournament: false,
                communityRewards: false,
                exclusiveEvents: false,
                stripePriceId: null,
                stripeProductId: null
            };
        },
        edit(index) {
            const c = this;
            let data = c.model.subscriptions[index];

            if (c.model.edit && c.model.subscription.id === data.id) {
                c.model.edit = false;
                return;
            }

            c.model.edit = true;
            c.model.subscription = {
                id: data.id,
                name: data.subsName,
                price: data.subsPrice,
                standard: data.standard,
                ultra: data.ultra,
                legendary: data.legendary,
                primeChest: data.primeChest,
                ultraChest: data.ultraChest,
                legendaryChest: data.legendaryChest,
                tournament: data.tournament || false,
                streamerTournament: data.streamerTournament || false,
                communityRewards: data.communityRewards || false,
                exclusiveEvents: data.exclusiveEvents || false,
                stripePriceId: data.stripePriceId || null,
                stripeProductId: data.stripeProductId || null
            };
        },
        save() {
            const c = this;
            const data = c.model.subscription;

            if (!data.name) {
                utils.alert.error('Name is required');
                return;
            }

            if (data.standard === null || data.standard === undefined) {
                utils.alert.error('Standard is required');
                return;
            }

            if (data.ultra === null || data.ultra === undefined) {
                utils.alert.error('Ultra is required');
                return;
            }

            if (data.legendary === null || data.legendary === undefined) {
                utils.alert.error('Legendary is required');
                return;
            }

            if (data.primeChest === null || data.primeChest === undefined) {
                utils.alert.error('Prime Chest is required');
                return;
            }

            if (data.ultraChest === null || data.ultraChest === undefined) {
                utils.alert.error('Ultra Chest is required');
                return;
            }

            if (data.legendaryChest === null || data.legendaryChest === undefined) {
                utils.alert.error('Legendary Chest is required');
                return;
            }

            subscriptionService.save(c.model.subscription)
            .then(function(response) {
                utils.alert.success(response.data.message);

                // Sync with Stripe (skip Free Tier)
                if (data.id !== 'F06D3E4A-B82A-48C5-A35B-A49E4F204B5E' && data.price > 0) {
                    c.syncStripeProduct(data.id, data.name, data.price);
                }

                c.get();
                setTimeout(function() {
                    c.reset();
                }, 500);
            })
            .catch(function(error) {
                utils.alert.error(error);
            });
        },
        saveBanner() {
            const c = this;

            const bannerConfig = { ...c.model.banner };
            delete bannerConfig.id;

            const compiledHTML = c.generateBannerHTML();
            
            const data = {
                id: c.model.banner.id,
                active: c.model.banner.active,
                config: JSON.stringify(bannerConfig),
                compiled: compiledHTML
            };

            subscriptionService.saveBanner(data)
            .then(function(response) {
                utils.alert.success('Banner saved successfully');
                if (response.data && response.data.id) {
                    c.model.banner.id = response.data.id;
                }
                
                // Broadcast banner update to all connected users via WebSocket
                c.broadcastBannerUpdate(c.model.banner.active, compiledHTML);
            })
            .catch(function(error) {
                utils.alert.error('Error saving banner');
                console.log(error);
            });
        },
        broadcastBannerUpdate(active, compiled) {
            const c = this;
            
            try {
                const ws = new WebSocket(utils.getWsUrl());
                
                ws.onopen = function() {
                    const message = {
                        message: 'promotionalBannerUpdate',
                        active: active,
                        compiled: compiled
                    };
                    
                    ws.send(JSON.stringify(message));
                    console.log('[AdminSubscription] Banner update broadcasted to all users');
                    
                    // Close connection after sending
                    setTimeout(function() {
                        ws.close();
                    }, 100);
                };
                
                ws.onerror = function(error) {
                    console.log('[AdminSubscription] WebSocket broadcast failed:', error);
                };
            } catch (error) {
                console.log('[AdminSubscription] WebSocket unavailable for broadcast:', error);
            }
        },
        generateBannerHTML() {
            const c = this;
            const b = c.model.banner;

            // Generate background CSS
            let backgroundCSS = '';
            if (b.backgroundType === 'color') {
                backgroundCSS = `background-color: ${b.backgroundColor};`;
            } else if (b.backgroundType === 'gradient') {
                backgroundCSS = `background: linear-gradient(${b.gradientDirection}, ${b.gradientStart}, ${b.gradientEnd});`;
            } else if (b.backgroundType === 'image') {
                backgroundCSS = `background-image: url(${b.backgroundImage}); background-size: ${b.backgroundSize}; background-position: center; background-repeat: no-repeat;`;
            }

            // Generate flex direction based on image position
            const flexDirection = b.displayImage && b.imagePosition === 'left' ? 'row-reverse' : 'row';
            
            // Generate content alignment
            let justifyContent = 'flex-start';
            if (b.contentPosition === 'center') justifyContent = 'center';
            else if (b.contentPosition === 'right') justifyContent = 'flex-end';

            const paddingValues = b.buttonPadding.split(' ').map(v => v + 'px').join(' ');

            const html = `
<style>
.promo-banner {
    display: flex;
    align-items: center;
    justify-content: ${justifyContent};
    flex-direction: ${flexDirection};
    min-height: ${b.height}px;
    padding: ${b.padding}px;
    border-radius: ${b.borderRadius}px;
    ${backgroundCSS}
    position: relative;
    overflow: hidden;
}
.promo-banner-content {
    position: relative;
    z-index: 2;
    flex: 1;
    text-align: ${b.contentAlignment};
}
.promo-banner-title {
    color: ${b.titleColor};
    font-size: ${b.titleSize}px;
    font-weight: bold;
    margin: 0 0 10px 0;
}
.promo-banner-description {
    color: ${b.descriptionColor};
    font-size: ${b.descriptionSize}px;
    margin: 0 0 15px 0;
}
.promo-banner-discount {
    display: inline-block;
    background-color: ${b.discountBgColor};
    color: ${b.discountTextColor};
    padding: 5px 15px;
    border-radius: 20px;
    font-weight: bold;
    font-size: 14px;
    margin-right: 10px;
}
.promo-banner-button {
    background-color: ${b.buttonBgColor};
    color: ${b.buttonTextColor};
    border: none;
    border-radius: ${b.buttonBorderRadius}px;
    padding: ${paddingValues};
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    text-decoration: none;
    display: inline-block;
}
.promo-banner-button:hover {
    opacity: 0.9;
}
.promo-banner-image {
    width: ${b.imageWidth}px;
    height: ${b.imageHeight}px;
    object-fit: contain;
    margin-left: ${b.imagePosition === 'right' ? '20px' : '0'};
    margin-right: ${b.imagePosition === 'left' ? '20px' : '0'};
    position: relative;
    z-index: 2;
}
</style>
<div class="promo-banner">
    ${b.displayImage ? `<img src="${b.displayImage}" alt="Promo" class="promo-banner-image">` : ''}
    <div class="promo-banner-content">
        <h3 class="promo-banner-title">${b.title}</h3>
        <p class="promo-banner-description">${b.description}</p>
        ${b.discountText ? `<span class="promo-banner-discount">${b.discountText}</span>` : ''}
        ${b.buttonText ? `<a href="${b.buttonLink}" class="promo-banner-button">${b.buttonText}</a>` : ''}
    </div>
</div>`;

            return html;
        },
        syncStripeProduct(subscriptionId, name, price) {
            const c = this;

            const data = {
                subscriptionId: subscriptionId,
                name: name,
                price: price
            };

            axios.post('/api/stripe/sync-product.php', data)
                .then(function(response) {
                    if (response.data && response.data.success) {
                        console.log('Stripe product synced:', response.data);
                        utils.alert.success('Stripe product created/updated: ' + response.data.stripePriceId);

                        // Refresh subscription list to get updated Stripe IDs
                        setTimeout(function() {
                            c.get();
                        }, 1000);
                    }
                })
                .catch(function(error) {
                    console.error('Stripe sync error:', error);
                    const errorMessage = error.response?.data?.error || 'Failed to sync with Stripe';
                    utils.alert.error(errorMessage);
                });
        }
    }
})